export default __webpack_public_path__ + "571568bc43745f2060ac465aea554da2.svg";